export default class Link {
    constructor() {
        this.link = document.createElement("a");

    }

    setPath (href) {
        this.link.href = href;
    }

    getPath (href) {
        var path = this.link.pathname;
        if (path[0] != '/') {
            path = '/' + path;
        }
        return path;
    }

    getSearch () {
        return this.link.search;
    }

    getHash (href) {
        return this.link.hash;
    }

    getLang () {
        var path = this.link.pathname;
        path.split('/');
        if (path[0].lenght == 2)
            return path[0]
        return false
    }
}


// WEBPACK FOOTER //
// ./core/xhrController/link.js